// create and export lib object container
import buildOC from "./ioc";
const libOC = buildOC();
export default libOC;
